import { Button } from '@vds/buttons';
import { convertStringToElements } from '@vds/html-parsers';
import { Modal, ModalBody, ModalFooter } from '@vds/modals';
import { Body, Title } from '@vds/typography';
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Table, TableBody, TableHead, TableHeader, TableRow, Cell } from '@vds/tables'
import { Line } from '@vds/lines';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { getDestList } from '../../shared/utils/globalUtils';
import { useSelector } from 'react-redux';
import {setModelTagging} from '../utils/tagging'
import { unauth } from '../utils/globalConfig';
import {getDevicesPayload } from '../utils/globalUtils';


const Space = styled.div`
padding-top: 12px;
`

const CountryListModal = ({ setCountryListModal, isTravelPass }) => {

    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth } = useSelector(state => state?.persistantReducer);
    const navigate = useNavigate();
    

    const getsDevicesPayloadsUnauth = () => {
        let payloads = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payloads;
    }
    
    const Payload = unauth ? getsDevicesPayloadsUnauth() : getDevicesPayload(selectedDates, selectedDestinations);
    const { data } = useGetDevicesAndPlansByNameQuery(Payload)

    
    const [showCountryListObject, setCountryListObject] = useState();
    const [showModal, setShowModal] = useState(true);
    const [inputText, setInputText] = useState("");
    useEffect(() => {
        setCountryListObject(data?.body?.data?.planDetailsLand?.countryListDetails);
    }, [data]);

   
    const onOpenedChange = value => {
        setModelTagging('countryListModal', 'countryListModal', value);
        if (!value) {
            navigate(-1, { replace: true })
            setCountryListModal(false)
        }
    };

    const onCloseModal = () => {
        setShowModal(false);
    }
    let inputHandler = (e) => {
        //convert input text to lower case
        var lowerCase = e.target.value.toLowerCase();
        setInputText(lowerCase);
      };
    const filteredData = showCountryListObject?.countryList?.filter((el) => {
        if (inputText === '') {
            return el;
        } else {
            return el?.country?.toLowerCase()?.includes(inputText)
        }
    })
    return (
        <>
            <Modal
                opened={showModal}
                onOpenedChange={onOpenedChange}
                id = "countryListModal"
            >
                <ModalBody>
                    <Body bold size="large">{isTravelPass? showCountryListObject?.heading : showCountryListObject?.monthlyPlanHeading}</Body>
                    <Space />
                    <Body size="large" >{isTravelPass && showCountryListObject?.subtext}</Body>
                    <Space />
                    <Title size="medium">{showCountryListObject?.labelText}</Title>
                    <Space />
                    <TextField
                        data-testid="textField"
                        id="outlined-basic"
                        onChange={inputHandler}
                        variant="outlined"
                        fullWidth
                        label="Search"
                    />
                    <Space />
                    <Line type="primary" />
                    <Table
                        striped={false}
                        surface="light"
                        padding="compact"
                    >
                        <TableHead bottomLine >
                            <TableHeader>{showCountryListObject?.countryText}</TableHeader>
                            <TableHeader>{showCountryListObject?.costText}</TableHeader>
                        </TableHead>
                        <TableBody>
                            {filteredData?.map((subItem, i) => {
                                return (
                                    <>
                                        <TableRow>
                                            <Cell>{subItem?.country}</Cell>
                                        </TableRow>

                                    </>)
                            })}
                        </TableBody>
                    </Table>
                </ModalBody>
                <ModalFooter>
                    <Button data-testid="countryListModalClose"size="large" width="100%" use="secondary" onClick={() => onCloseModal()}>{showCountryListObject?.closeButtonText}</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default CountryListModal;